import { getApiInstance } from "../../AppService";
import {
  ADD_BULK_CHILD_VARIANT,
  ADD_VARIANT,
  EDIT_VARIANT,
  UPDATE_BULK_CHILD_VARIANT,
} from "../../constant";

export const addNewProductVariantApi = async ({ businessId, data }) => {
  try {
    const instance = getApiInstance({
      header: {
        businessid: businessId,
      },
    });
    const response = await instance.post(ADD_VARIANT, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const editMainProductVariantApi = async ({ businessId, data }) => {
  try {
    const instance = getApiInstance({
      header: {
        businessid: businessId,
      },
    });
    const response = await instance.post(EDIT_VARIANT, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const addNewProductChildVariantApi = async ({ businessId, data }) => {
  try {
    const instance = getApiInstance({
      header: {
        businessid: businessId,
      },
    });
    const response = await instance.post(ADD_BULK_CHILD_VARIANT, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const updateBulkChildVariantApi = async ({ businessId, data }) => {
  try {
    const instance = getApiInstance({
      header: {
        businessid: businessId,
      },
    });
    const response = await instance.post(UPDATE_BULK_CHILD_VARIANT, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
